import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ZodError } from "zod";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error(error);
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry(failureCount, error) {
        if (error instanceof ZodError) {
          return false;
        } else {
          return failureCount < 2;
        }
      },
    },
  },
});

export const ReactQueryProvider = ({ children }: { children: React.ReactNode }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
